import * as XLSX from "xlsx";
import moment from "moment/moment";
import { dateFormats } from "@/Pages/CreateCampaignPage/Constants/DateFormats";
import { throwNewToastError } from "@/Utils/MainUtils";

export const getImportedDateList = (
  worksheet: XLSX.WorkSheet,
): string[] | null => {
  const result: (string | null)[] = Object.keys(worksheet)
    .filter((cell) => cell.match(/[a-zA-Z]+1$/) && cell !== "A1")
    .map((dateCell) => {
      const startDate = new Date("01/01/1900");

      if (
        "v" in worksheet[dateCell] &&
        typeof worksheet[dateCell].v === "number"
      ) {
        return moment(
          new Date(startDate.setDate(worksheet[dateCell].v - 1)),
        ).format("YYYY-MM-DD");
      } else if (
        "w" in worksheet[dateCell] &&
        moment(worksheet[dateCell].w, dateFormats).isValid()
      ) {
        return moment(worksheet[dateCell].w, dateFormats).format("YYYY-MM-DD");
      } else {
        throwNewToastError(
          "Change the date format or contact the administrator",
        );
        return null;
      }
    });

  if (result.includes(null)) {
    return null;
  }

  return result as string[];
};
